module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title15"
    }
  }, [_c('h1', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title15"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781783468874_als01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Other volumes in this series")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781783468874_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781783468874_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781783468874_ack01"
    }
  }, [_vm._v("Acknowledgements")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783468874_fm03"
    }
  }, [_vm._v("Prologue")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783468874_c01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 1")]), _vm._v(" - ‘Mad Tuesday’")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783468874_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 2")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The ‘Stillborn Army’")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783468874_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 3")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Moskitopanik!")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783468874_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Waking Skies At Sunrise")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783468874_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Stand Up and Hook Up!")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783468874_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Moffen Are Coming!")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783468874_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 7")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("We’ve Got To Get the Bridge!")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781783468874_ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Index")])]), _c('br'), _vm._v(" "), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58b1fb36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783468874_toc01.vue
// module id = 66
// module chunks = 0